import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as printJS from 'print-js';
import { AppService } from './app.service';
import { Pageable } from 'src/app/pageable';
import { Observable } from 'rxjs';
import { Page } from 'src/app/page';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceProviderSubjectService {

  constructor(private httpClient: HttpClient, private app: AppService) { }

  getFilteredPage(body: any): Observable<Page<any>> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });

    return this.httpClient.post(this.app.getServiceProvidersUrl() + environment.getServiceProviderPaginationUrl, body, { headers }) as Observable<any>;
  }

  insertSubjectInServiceProvider(body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });
    return this.httpClient.post(this.app.getServiceProvidersUrl() + environment.addServiceProviderSubjectUrl, body, { headers }) as Observable<any>;
  }

  printPdf(body) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });

    this.httpClient.post(this.app.getServiceProvidersUrl() + environment.exportPdfServiceProviderSubjectUrl, body, { responseType: 'blob', headers }).subscribe(data => {
      const file = new Blob([data], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      printJS(fileURL);
    });
  }

  exportCSV(body, filename) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });

    this.httpClient.post(this.app.getServiceProvidersUrl() + environment.exportCsvServiceProviderSubjectUrl, body, { responseType: 'blob', headers }).subscribe(data => {
      const parts = [];
      parts.push('\uFEFF');
      parts.push(data);
      const file = new Blob(parts, { type: 'text/csv' });
      const fileURL = URL.createObjectURL(file);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = fileURL;
      a.download = filename + '.csv';
      a.click();
      window.URL.revokeObjectURL(fileURL);
      a.remove();
    });
  }

  getCurrentServiceProviderSubject(id: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
    });
    return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.getServiceProviderSubjectUrl + id, { headers }) as Observable<any>;
  }

  getCurrentServiceProviderSubjectDetails(subjectId: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
    });
    return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.getServiceProviderSubjectDetailsUrl + subjectId, { headers }) as Observable<any>;
  }

  getHistoryPage(pageable: Pageable, id: any): Observable<Page<Object>> {
    const headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
    });
    return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.getServiceProviderSubjectHistory + id + '/' + pageable.pageNumber + '/' + pageable.pageSize, { headers }) as Observable<any>;
  }

  getServiceProviderSubjectStatus(subjectId: any, serviceProviderId: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
    });
    return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.getServiceProviderSubjectStatus + subjectId + '/' + serviceProviderId, { headers }) as Observable<any>;
  }

  addServiceProviderSubjectDetails(body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });
    return this.httpClient.post(this.app.getServiceProvidersUrl() + environment.addServiceProviderSubjectDetailsUrl, body, { headers }) as Observable<any>;
  }

  checkUserExistsByJmbg(jmbg: string) {
    const headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
    });
    return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.checkIfUserExistsByJmbg + jmbg, { headers }) as Observable<any>;
  }

  getServiceProviderSubjectRecords(pageable: Pageable, subjectId: any, serviceProviderId: any): Observable<Page<Object>> {
    const headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
    });
    return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.getServiceProviderSubjectRecords + subjectId + '/' + serviceProviderId + '/' + pageable.pageNumber + '/' + pageable.pageSize, { headers }) as Observable<any>;
  }

  addServiceProviderSubjectRecord(body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });
    return this.httpClient.post(this.app.getServiceProvidersUrl() + environment.addServiceProviderSubjectRecord, body, { headers }) as Observable<any>;
  }

  deleteServiceProviderSubjectRecord(id: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });
    return this.httpClient.delete(this.app.getServiceProvidersUrl() + environment.deleteServiceProviderSubjectRecord + id, { headers }) as Observable<any>;
  }

  getServiceProviderSubjectRecordOutcomeStatuses() {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });
    return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.getServiceProviderSubjectRecordOutcomeStatuses, { headers }) as Observable<any>;
  }

  archiveSubject(id: string | number, archiveData: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });
    return this.httpClient.put(this.app.getServiceProvidersUrl() + environment.archiveServiceProviderSubjectUrl + id, archiveData, { headers }) as Observable<any>;
  }

  unarchiveSubject(id: string | number, unarchiveData: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });
    return this.httpClient.put(this.app.getServiceProvidersUrl() + environment.unarchiveServiceProviderSubjectUrl + id, unarchiveData, { headers }) as Observable<any>;
  }

  addDossierOwner(serviceProviderSubjectId: any, ownerId: any, ownerFullName: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });
    const body = {
      serviceProviderSubjectId: serviceProviderSubjectId,
      ownerId: ownerId,
      ownerFullName: ownerFullName,
    };
    return this.httpClient.put(this.app.getServiceProvidersUrl() + environment.addDossierOwnerServiceProviderSubject, body, { headers }) as Observable<any>;
  }

  submitAssessmentForm(assessmentFormData: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    return this.httpClient.post(this.app.getServiceProvidersUrl() + environment.submitServiceProviderAssessmentForm, assessmentFormData, { headers }) as Observable<any>;
  }

  submitIntakeAssessmentForm(intakeAssessmentFormData: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    return this.httpClient.post(this.app.getServiceProvidersUrl() + environment.submitServiceProviderIntakeAssessmentForm, intakeAssessmentFormData, { headers }) as Observable<any>;
  }

  submitIndividualServicePlanForm(planFormData: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    return this.httpClient.post(this.app.getServiceProvidersUrl() + environment.submitIndividualServicePlanForm, planFormData, { headers }) as Observable<any>;
  }

  previewAssessmentForm(assessmentFormData: any){
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    this.httpClient
    .put(this.app.getServiceProvidersUrl() + environment.previewServiceProviderAssessmentForm,  assessmentFormData, { responseType: 'blob', headers })
    .subscribe(data => {
      const file = new Blob([data], { type: 'application/pdf' });      
      const fileURL = URL.createObjectURL(file);      
      printJS(fileURL);
    });
  }

  previewIntakeAssessmentForm(intakeAssessmentFormData: any){
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    this.httpClient
    .put(this.app.getServiceProvidersUrl() + environment.previewServiceProviderIntakeAssessmentForm,  intakeAssessmentFormData, { responseType: 'blob', headers })
    .subscribe(data => {
      const file = new Blob([data], { type: 'application/pdf' });      
      const fileURL = URL.createObjectURL(file);      
      printJS(fileURL);
    });
  }

  previewIndividualServicePlanForm(planFormData: any){
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    this.httpClient
    .put(this.app.getServiceProvidersUrl() + environment.previewIndividualServicePlanForm,  planFormData, { responseType: 'blob', headers })
    .subscribe(data => {
      const file = new Blob([data], { type: 'application/pdf' });      
      const fileURL = URL.createObjectURL(file);      
      printJS(fileURL);
    });
  }

  getAssessmentForm(subjectId: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.getAssessmentFormBySubjectIdUrl + subjectId, { headers }) as Observable<any>;
  }

  getIntakeAssessmentForm(subjectId: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.getIntakeAssessmentFormBySubjectIdUrl + subjectId, { headers }) as Observable<any>;
  }

  getIndividualServicePlanForm(subjectId: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.getIndividualServicePlanFormBySubjectIdUrl + subjectId, { headers }) as Observable<any>;
  }

  generateFunctionalEfficiencyAssessmentScale(body) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });

    return this.httpClient.post(this.app.getServiceProvidersUrl() + environment.generateFunctionalEfficiencyAssessmentScale, body, { headers }) as Observable<any>;
  }

  saveFunctionalEfficiencyAssessmentScale(body) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });

    return this.httpClient.post(this.app.getServiceProvidersUrl() + environment.saveFunctionalEfficiencyAssessmentScale, body, { headers }) as Observable<any>;
  }

  getEfficiencyScaleBySubjectIdUrl(subjectId: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });

    return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.getEfficiencyScaleBySubjectIdUrl + subjectId, { headers }) as Observable<any>;
  }

  previewEfficiencyScaleForm(scaleFormData: any){
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    this.httpClient
    .put(this.app.getServiceProvidersUrl() + environment.previewEfficiencyScaleForm, scaleFormData, { responseType: 'blob', headers })
    .subscribe(data => {
      const file = new Blob([data], { type: 'application/pdf' });      
      const fileURL = URL.createObjectURL(file);      
      printJS(fileURL);
    });
  }

}
